import { useSelector } from 'react-redux';
import { selectProfile } from 'screens/Login/selectors';
import es from './locales/es';
import en from './locales/en';
import pt from './locales/pt';

const locales = { es, en, pt };

const useTranslation = () => {
	const profile = useSelector(selectProfile);
	const language = profile?.user?.settings?.language || 'es';
	return { t: locales[language] || locales.es, language };
};

export default useTranslation;
